import React from "react";
import { AxiosResponse } from "axios";
import { makeStyles, Theme } from "@material-ui/core/styles";
import CustomAlert from "../../components/Alert/CustomAlert";
import TestRequestApi from "../../api/services/TestRequestApi";
import FileUpload from "./FileUpload";
import useEnv from "../../hooks/env";

const useStyles = makeStyles((theme: Theme) => ({
  marginBottom5: {
    marginBottom: theme.spacing(5),
  },
  subHeading: {
    display: "block",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    marginBottom: theme.spacing(1),
  },
}));

const ACCEPTED_FILES = {
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};
const MAX_FILE_SIZE_MB = 5;
const SUCCESS_MESSAGE = "Successfully updated country list and CSC region mapping";

const CountryListUpload: React.FC = () => {
  const classes = useStyles();
  const { api } = useEnv();
  const testRequestApi = new TestRequestApi(api);

  const handleUpload = (
    payload: FormData,
    progressCallback?: (progressEvent: { loaded: number; total: number }) => void,
  ): Promise<AxiosResponse> => {
    return testRequestApi.updateCountryList(payload, progressCallback);
  };

  return (
    <div className={classes.marginBottom5}>
      <div className={classes.subHeading}>Country List with Default CSC Region Upload</div>
      <CustomAlert
        severity="info"
        className={classes.marginBottom5}
        text="
          Uploading a new country list directly updates the country list.
      "
      />
      <FileUpload
        acceptedFiles={ACCEPTED_FILES}
        buttonLabel="Upload Country List"
        maxFileSizeMB={MAX_FILE_SIZE_MB}
        downloadTemplate={() => testRequestApi.downloadTemplate()}
        successMessage={SUCCESS_MESSAGE}
        upload={handleUpload}
      />
    </div>
  );
};

export default CountryListUpload;
